
    import {Vue, Component, Watch} from "vue-property-decorator";
    import {menus} from "@/frame/layout/menus";

    @Component({
        components: {
           
        },
    })
    export default class MyLayout extends Vue {
        // 菜单数组
        menus: any = menus;

        activeIndex:string='home'
        left:string='200px'
        container:any=document
        el:any=document.documentElement
        visible:boolean=false
        throttledScrollHandler:any=null

        mounted() {
            this.throttledScrollHandler = this.throttle(300, this.onScroll);
            this.container.addEventListener('scroll', this.throttledScrollHandler);
        }
        beforeDestroy() {
            this.container.removeEventListener('scroll', this.throttledScrollHandler);
        }

        goLogin(where:string){
            if(where==='goverment'){
                window.open("http://gges.feiyuanenv.com:10032/")
            }else if(where==='enterprise'){
                window.open("http://gges.feiyuanenv.com:10031/")
            }
        }

        //点击菜单栏跳转到指定页面
        handleSelect(keyPath:any) {
        if(keyPath.length>1&&keyPath!==this.$route.fullPath){
            this.$router.push(keyPath)
        }
        // else if(keyPath&&keyPath[0]==='/technical_services'){
        //     this.$router.push(keyPath.join('/'))
        // }
        }
        showMenu(e:any){
            this.left = e.target.dataset.width
        }
        goAnchor(selector:any) {
            let anchor = this.$el.querySelector(selector)
            this.el.scrollTop = anchor.offsetTop
            
        }
        goTop(){
            window.scrollTo(0,0)
        }
        onScroll() {
            const scrollTop = this.el.scrollTop;
            this.visible = scrollTop >= 200;
        }
        throttle(time:number,fn:Function){
            let _this = this
            let lastTime = 0
            return function () {
                let nowTime = new Date().getTime()
                setTimeout(()=>{
                    if(nowTime-lastTime>=time){
                        fn.apply(_this,arguments)
                        lastTime = nowTime
                    }
                })
            }
        }
        // @Watch("$route")
        // "watchRoute"(newVal: any,oldVal: any) {
            
        // }
        @Watch("$route.path",{ deep: true, immediate: true })
        "watchPath"(newVal: any,oldVal: any) {
            let arr = newVal.split('/')
            for (const item of arr) {
                if(item){
                    if(item==='news_detail'||item==='projects_detail'){
                        this.activeIndex = 'news' 
                        return
                    }else{
                        this.activeIndex = item 
                        return
                    }
                }
            }
        }
        @Watch("$route.hash",{ deep: true, immediate: true })
        "watchHash"(newVal: any,oldVal: any) {
            if(newVal&&newVal!==oldVal){
                this.$nextTick(() => {
                this.goAnchor(newVal)
            })
            }
            
        }
    }
